import React, { useState, useEffect } from "react";
import axios from "axios";
import myConfig from "../../configs/config";
import { withTranslation } from "react-i18next";
import { Link, withRouter, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { usePendingMachineRegistration } from "../../contexts/PendingMachineRegistrationContext";
import SidebarToolInfoModal from "../../components/SidebarToolInfoModal";
import {
  MACHINE_SPEED_ALERT_HELP_TITLE,
  MachineSpeedAlertHelpContent,
} from "./machineSpeedAlertHelpContent";
import {
  MACHINE_FUEL_ALERT_HELP_TITLE,
  MachineFuelAlertHelpContent,
} from "./machineFuelAlertHelpContent";
import {
  MACHINE_FORM_HELP_TITLE,
  MachineFormHelpContent,
} from "./machineFormHelpContent";
import { FaInfoCircle } from "react-icons/fa";
import MachineChecklistEditor from "./MachineChecklistEditor";

function FormMachine(props) {
  const farmId = props.match.params.farm_id;
  const { refreshPendingRegistrations } = usePendingMachineRegistration();
  const machineId =
    props.match.params.machine_id === "add"
      ? -1
      : props.match.params.machine_id;

  const hasMachine = machineId !== -1;
  const history = useHistory();

  const [ident, setIdent] = useState("");
  const [manufactureYear, setManufactureYear] = useState("");
  const [deviceUid, setDeviceUid] = useState("");
  const [chassisNumber, setChassisNumber] = useState("");
  const [registrationNotes, setRegistrationNotes] = useState("");
  const [meterType, setMeterType] = useState("hour_meter");
  const [requireHectares, setRequireHectares] = useState(false);
  const [requirePanelPhoto, setRequirePanelPhoto] = useState(true);
  const [requireHectaresPhoto, setRequireHectaresPhoto] = useState(false);
  const [preStartChecklist, setPreStartChecklist] = useState([]);
  const [requirePreStartChecklist, setRequirePreStartChecklist] = useState(false);
  const [requireFuelingPanelPhoto, setRequireFuelingPanelPhoto] = useState(true);
  const [requireFuelingGaugePhoto, setRequireFuelingGaugePhoto] = useState(false);
  const [requireFuelingSupplyPhoto, setRequireFuelingSupplyPhoto] = useState(false);
  const [requireFuelingHectares, setRequireFuelingHectares] = useState(false);
  const [requireFuelingHectaresPhoto, setRequireFuelingHectaresPhoto] = useState(false);
  const [meterReadingProblem, setMeterReadingProblem] = useState(false);
  const [meterReadingStaleCount, setMeterReadingStaleCount] = useState(0);
  const [maxSpeedKmh, setMaxSpeedKmh] = useState("");
  const [speedAlertWhatsappEnabled, setSpeedAlertWhatsappEnabled] = useState(false);
  const [speedAlertWhatsappUserId, setSpeedAlertWhatsappUserId] = useState("");
  const [farmAdmins, setFarmAdmins] = useState([]);
  const [showSpeedAlertHelp, setShowSpeedAlertHelp] = useState(false);
  const [tankCapacityLiters, setTankCapacityLiters] = useState("");
  const [fuelConsumptionMinLph, setFuelConsumptionMinLph] = useState("");
  const [fuelConsumptionMaxLph, setFuelConsumptionMaxLph] = useState("");
  const [fuelConsumptionMinKpl, setFuelConsumptionMinKpl] = useState("");
  const [fuelConsumptionMaxKpl, setFuelConsumptionMaxKpl] = useState("");
  const [showFuelAlertHelp, setShowFuelAlertHelp] = useState(false);
  const [showFormHelp, setShowFormHelp] = useState(false);
  const [title, setTitle] = useState("Cadastrar máquina");

  const usesHourFuelLimits =
    meterType === "hour_meter" || meterType === "both";
  const usesKmFuelLimits =
    meterType === "odometer" || meterType === "both";

  async function getCurrentMachine() {
    const response = await axios({
      baseURL: `${myConfig.API_URL}/equipment/${machineId}/`,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    });

    const data = response.data;
    setTitle("Editar máquina");
    setIdent(data.ident || "");
    setManufactureYear(
      data.manufacture_year != null ? String(data.manufacture_year) : ""
    );
    setDeviceUid(data.device_uid || "");
    setChassisNumber(data.chassis_number || "");
    setRegistrationNotes(data.registration_notes || "");
    setMeterType(data.meter_type || "hour_meter");
    setRequireHectares(Boolean(data.require_hectares));
    setRequirePanelPhoto(
      data.require_panel_photo !== undefined ? Boolean(data.require_panel_photo) : true
    );
    setRequireHectaresPhoto(Boolean(data.require_hectares_photo));
    setPreStartChecklist(
      Array.isArray(data.pre_start_checklist) ? data.pre_start_checklist : []
    );
    setRequirePreStartChecklist(Boolean(data.require_pre_start_checklist));
    setRequireFuelingPanelPhoto(
      data.require_fueling_panel_photo !== undefined
        ? Boolean(data.require_fueling_panel_photo)
        : true
    );
    setRequireFuelingGaugePhoto(Boolean(data.require_fueling_gauge_photo));
    setRequireFuelingSupplyPhoto(Boolean(data.require_fueling_supply_photo));
    setRequireFuelingHectares(Boolean(data.require_fueling_hectares));
    setRequireFuelingHectaresPhoto(Boolean(data.require_fueling_hectares_photo));
    setMeterReadingProblem(Boolean(data.meter_reading_problem));
    setMeterReadingStaleCount(Number(data.meter_reading_stale_count || 0));
    setMaxSpeedKmh(
      data.max_speed_kmh != null && data.max_speed_kmh !== ""
        ? String(data.max_speed_kmh)
        : ""
    );
    setSpeedAlertWhatsappEnabled(Boolean(data.speed_alert_whatsapp_enabled));
    setSpeedAlertWhatsappUserId(
      data.speed_alert_whatsapp_user != null
        ? String(data.speed_alert_whatsapp_user)
        : ""
    );
    setTankCapacityLiters(
      data.capacity != null && data.capacity !== "" ? String(data.capacity) : ""
    );
    setFuelConsumptionMinLph(
      data.fuel_consumption_min_lph != null && data.fuel_consumption_min_lph !== ""
        ? String(data.fuel_consumption_min_lph)
        : ""
    );
    setFuelConsumptionMaxLph(
      data.fuel_consumption_max_lph != null && data.fuel_consumption_max_lph !== ""
        ? String(data.fuel_consumption_max_lph)
        : ""
    );
    setFuelConsumptionMinKpl(
      data.fuel_consumption_min_kpl != null && data.fuel_consumption_min_kpl !== ""
        ? String(data.fuel_consumption_min_kpl)
        : ""
    );
    setFuelConsumptionMaxKpl(
      data.fuel_consumption_max_kpl != null && data.fuel_consumption_max_kpl !== ""
        ? String(data.fuel_consumption_max_kpl)
        : ""
    );
  }

  async function loadFarmAdmins() {
    try {
      const response = await axios({
        baseURL: `${myConfig.API_URL}/accounts/?farm_id=${farmId}`,
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });
      setFarmAdmins(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setFarmAdmins([]);
    }
  }

  function getFormData() {
    const formData = new FormData();
    formData.append("ident", ident.trim());
    formData.append("farm", farmId);
    formData.append("device_uid", deviceUid.trim());
    if (manufactureYear.trim()) {
      formData.append("manufacture_year", manufactureYear.trim());
    }
    formData.append("chassis_number", chassisNumber.trim());
    formData.append("registration_notes", registrationNotes.trim());
    formData.append("meter_type", meterType);
    formData.append("require_hectares", requireHectares ? "true" : "false");
    formData.append("require_panel_photo", requirePanelPhoto ? "true" : "false");
    formData.append(
      "require_hectares_photo",
      requireHectaresPhoto ? "true" : "false"
    );
    formData.append("pre_start_checklist", JSON.stringify(preStartChecklist));
    formData.append(
      "require_pre_start_checklist",
      requirePreStartChecklist ? "true" : "false"
    );
    formData.append(
      "require_fueling_panel_photo",
      requireFuelingPanelPhoto ? "true" : "false"
    );
    formData.append(
      "require_fueling_gauge_photo",
      requireFuelingGaugePhoto ? "true" : "false"
    );
    formData.append(
      "require_fueling_supply_photo",
      requireFuelingSupplyPhoto ? "true" : "false"
    );
    formData.append(
      "require_fueling_hectares",
      requireFuelingHectares ? "true" : "false"
    );
    formData.append(
      "require_fueling_hectares_photo",
      requireFuelingHectaresPhoto ? "true" : "false"
    );
    if (maxSpeedKmh.trim()) {
      formData.append("max_speed_kmh", maxSpeedKmh.trim());
    }
    formData.append(
      "speed_alert_whatsapp_enabled",
      speedAlertWhatsappEnabled ? "true" : "false"
    );
    if (speedAlertWhatsappEnabled && speedAlertWhatsappUserId) {
      formData.append(
        "speed_alert_whatsapp_user",
        speedAlertWhatsappUserId
      );
    }
    if (tankCapacityLiters.trim()) {
      formData.append("capacity", tankCapacityLiters.trim());
    }
    if (usesHourFuelLimits && fuelConsumptionMinLph.trim()) {
      formData.append("fuel_consumption_min_lph", fuelConsumptionMinLph.trim());
    }
    if (usesHourFuelLimits && fuelConsumptionMaxLph.trim()) {
      formData.append("fuel_consumption_max_lph", fuelConsumptionMaxLph.trim());
    }
    if (usesKmFuelLimits && fuelConsumptionMinKpl.trim()) {
      formData.append("fuel_consumption_min_kpl", fuelConsumptionMinKpl.trim());
    }
    if (usesKmFuelLimits && fuelConsumptionMaxKpl.trim()) {
      formData.append("fuel_consumption_max_kpl", fuelConsumptionMaxKpl.trim());
    }
    return formData;
  }

  function showApiError(error) {
    let errorMsg = props.t("Falha ao salvar a máquina.");
    if (error.response && error.response.data) {
      errorMsg = "";
      Object.keys(error.response.data).forEach(function (key) {
        const value = error.response.data[key];
        errorMsg += `${key}: ${Array.isArray(value) ? value[0] : value} - `;
      });
    }
    toast.error(errorMsg, {
      position: "bottom-right",
      autoClose: 5000,
    });
  }

  async function createMachine() {
    try {
      const response = await axios({
        baseURL: `${myConfig.API_URL}/equipment/`,
        method: "post",
        data: getFormData(),
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });

      if (response.status === 201) {
        toast.success(
          `${props.t("Máquina")} ${props.t("cadastrada com sucesso")}!`,
          { position: "bottom-right", autoClose: 2000 }
        );
        setTimeout(() => {
          history.push(`/${farmId}/equipment/machine/`);
        }, 2000);
      }
    } catch (error) {
      showApiError(error);
    }
  }

  async function updateMachine() {
    try {
      const response = await axios({
        baseURL: `${myConfig.API_URL}/equipment/${machineId}/`,
        method: "patch",
        data: getFormData(),
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });

      if (response.status === 200) {
        refreshPendingRegistrations();
        toast.success(
          `${props.t("Máquina")} ${props.t("atualizada com sucesso")}!`,
          { position: "bottom-right", autoClose: 2000 }
        );
        setTimeout(() => {
          history.push(`/${farmId}/equipment/machine/`);
        }, 2000);
      }
    } catch (error) {
      showApiError(error);
    }
  }

  function handleSave(e) {
    e.preventDefault();
    if (!ident.trim()) {
      toast.error(props.t("Informe a identificação da máquina."));
      return;
    }
    if (!deviceUid.trim()) {
      toast.error(props.t("Informe o ID do dispositivo."));
      return;
    }
    if (speedAlertWhatsappEnabled && !speedAlertWhatsappUserId) {
      toast.error(
        props.t(
          "Selecione um gestor cadastrado para receber alertas via WhatsApp."
        )
      );
      return;
    }
    if (
      fuelConsumptionMinLph.trim() &&
      fuelConsumptionMaxLph.trim() &&
      Number.parseFloat(fuelConsumptionMinLph.replace(",", ".")) >
        Number.parseFloat(fuelConsumptionMaxLph.replace(",", "."))
    ) {
      toast.error(
        props.t("O consumo máximo deve ser maior ou igual ao consumo mínimo.")
      );
      return;
    }
    if (hasMachine) {
      updateMachine();
    } else {
      createMachine();
    }
  }

  useEffect(() => {
    loadFarmAdmins();
    if (hasMachine) {
      getCurrentMachine();
    }
  }, []);

  return (
    <>
      <div id="machine_form_container">
        <h2 style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>{props.t(title)}</span>
          <button
            type="button"
            className="sidebar-menu-info-btn"
            style={{ position: "static", margin: 0 }}
            title={props.t("Guia do cadastro de máquina")}
            aria-label={props.t("Guia do cadastro de máquina")}
            onClick={() => setShowFormHelp(true)}
          >
            <FaInfoCircle />
          </button>
        </h2>
        {hasMachine && meterReadingProblem ? (
          <div
            className="alert alert-danger"
            role="alert"
            style={{ marginBottom: 16 }}
          >
            {props.t(
              "Possível problema no medidor (horímetro/hodômetro): {{count}} ocorrência(s) com a mesma leitura no início e no fim do trabalho. Verifique o painel — horas, km e manutenções podem estar incorretos.",
              { count: meterReadingStaleCount }
            )}
          </div>
        ) : null}
        <p className="text-muted" style={{ marginBottom: 20 }}>
          {props.t(
            "Cadastro rápido: preencha só o essencial. A máquina aparece na plataforma pelo nome que você informar aqui."
          )}
        </p>
        <form method="POST" onSubmit={handleSave}>
          <div className="form-group">
            <label htmlFor="id_ident">{props.t("Identificação")} *</label>
            <small
              className="help-block text-muted"
              style={{ marginTop: 0, marginBottom: 8 }}
            >
              {props.t(
                "Referência da máquina na fazenda: nome ou código que a equipe usa para reconhecê-la no dia a dia. Costuma ser o número de frota colado na lateral da máquina ou um apelido definido pela frota."
              )}
            </small>
            <input
              type="text"
              id="id_ident"
              value={ident}
              onChange={(e) => setIdent(e.target.value)}
              name="ident"
              maxLength={35}
              className="form-control"
              placeholder={props.t("Ex.: 100.015 ou Trator 01")}
              required
            />
            <small className="help-block text-muted">
              {props.t(
                "No app de campo, o operador usa este código ao assumir a máquina (QR Code ou digitação)."
              )}
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="id_device_uid">{props.t("ID do dispositivo")} *</label>
            <small
              className="help-block text-muted"
              style={{ marginTop: 0, marginBottom: 8 }}
            >
              {props.t(
                "Código do rastreador GPS instalado na máquina. A plataforma usa este ID para telemetria e localização — é diferente do número de frota acima."
              )}
            </small>
            <input
              type="text"
              id="id_device_uid"
              value={deviceUid}
              onChange={(e) => setDeviceUid(e.target.value)}
              name="device_uid"
              className="form-control"
              placeholder={props.t("Ex.: código do rastreador")}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="id_chassis_number">
              {props.t("Número do chassi")}
            </label>
            <input
              type="text"
              id="id_chassis_number"
              value={chassisNumber}
              onChange={(e) => setChassisNumber(e.target.value)}
              name="chassis_number"
              maxLength={64}
              className="form-control"
              placeholder={props.t("Útil para compra de peças e manutenção")}
            />
          </div>

          <div className="form-group">
            <label htmlFor="id_manufacture_year">
              {props.t("Ano de fabricação")}
            </label>
            <input
              type="text"
              id="id_manufacture_year"
              value={manufactureYear}
              onChange={(e) => setManufactureYear(e.target.value)}
              name="manufacture_year"
              maxLength={4}
              className="form-control"
              placeholder="Ex.: 2022"
            />
          </div>

          <div className="form-group">
            <label htmlFor="id_meter_type">
              {props.t("Tipo de medidor")} *
            </label>
            <select
              id="id_meter_type"
              value={meterType}
              onChange={(e) => setMeterType(e.target.value)}
              name="meter_type"
              className="form-control"
              required
            >
              <option value="hour_meter">
                {props.t("Horímetro (horas)")}
              </option>
              <option value="odometer">
                {props.t("Hodômetro (quilômetros)")}
              </option>
              <option value="both">
                {props.t("Horímetro e hodômetro (ambos)")}
              </option>
            </select>
            <small className="help-block text-muted">
              {props.t(
                "Define o que o operador informa no app ao assumir a máquina. Caminhões usam km; tratores e máquinas agrícolas usam horas."
              )}
            </small>
          </div>

          <div className="form-group">
            <label>{props.t("App de campo — ao assumir a máquina")}</label>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={requirePanelPhoto}
                  onChange={(e) => setRequirePanelPhoto(e.target.checked)}
                />{" "}
                {props.t("Exigir foto do horímetro/hodômetro (abertura e fechamento)")}
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={requireHectares}
                  onChange={(e) => setRequireHectares(e.target.checked)}
                />{" "}
                {props.t("Exigir informar hectares do painel")}
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={requireHectaresPhoto}
                  onChange={(e) => setRequireHectaresPhoto(e.target.checked)}
                />{" "}
                {props.t("Exigir foto do contador de hectares (abertura e fechamento)")}
              </label>
            </div>
            <small className="help-block text-muted">
              {props.t(
                "Cada máquina pode ter regras diferentes. Quando a foto é exigida, ela será solicitada na abertura e no fechamento do trabalho. A conferência de inconsistências fica na plataforma web."
              )}
            </small>
          </div>

          <MachineChecklistEditor
            farmId={farmId}
            machineId={machineId}
            items={preStartChecklist}
            enabled={requirePreStartChecklist}
            onEnabledChange={setRequirePreStartChecklist}
            onChange={setPreStartChecklist}
            t={props.t}
          />

          <div className="form-group">
            <label htmlFor="id_max_speed_kmh" style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span>{props.t("Velocidade máxima (km/h)")}</span>
              <button
                type="button"
                className="sidebar-menu-info-btn"
                style={{ position: "static", margin: 0 }}
                title={props.t("Como funciona o alerta de velocidade?")}
                aria-label={props.t("Como funciona o alerta de velocidade?")}
                onClick={() => setShowSpeedAlertHelp(true)}
              >
                <FaInfoCircle />
              </button>
            </label>
            <input
              type="number"
              id="id_max_speed_kmh"
              value={maxSpeedKmh}
              onChange={(e) => setMaxSpeedKmh(e.target.value)}
              name="max_speed_kmh"
              min="1"
              max="200"
              step="1"
              className="form-control"
              placeholder={props.t("Ex.: 15")}
            />
            <small className="help-block text-muted">
              {props.t(
                "Acima deste limite, o alerta aparece em Ações pendentes em tempo real, mesmo com o trabalho ainda aberto. Clique no (i) para ver como funciona."
              )}
            </small>
          </div>

          <div className="form-group">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={speedAlertWhatsappEnabled}
                  onChange={(e) => {
                    setSpeedAlertWhatsappEnabled(e.target.checked);
                    if (!e.target.checked) {
                      setSpeedAlertWhatsappUserId("");
                    }
                  }}
                />{" "}
                {props.t("Enviar alerta de velocidade via WhatsApp")}
              </label>
            </div>
            <small className="help-block text-muted">
              {props.t(
                "Opcional. Sem esta opção, o alerta aparece só na plataforma web. Com ela, também envia WhatsApp ao gestor selecionado (pode haver custo por mensagem)."
              )}
            </small>
            {speedAlertWhatsappEnabled ? (
              <select
                className="form-control"
                style={{ marginTop: 8 }}
                value={speedAlertWhatsappUserId}
                onChange={(e) => setSpeedAlertWhatsappUserId(e.target.value)}
              >
                <option value="">
                  {props.t("Selecione o gestor cadastrado")}
                </option>
                {farmAdmins
                  .filter((admin) => admin.cell_phone)
                  .map((admin) => (
                    <option key={admin.id} value={admin.id}>
                      {admin.first_name} {admin.last_name} — {admin.cell_phone}
                    </option>
                  ))}
              </select>
            ) : null}
            {speedAlertWhatsappEnabled &&
            farmAdmins.filter((admin) => admin.cell_phone).length === 0 ? (
              <small className="help-block text-warning">
                {props.t(
                  "Nenhum gestor com telefone cadastrado. Cadastre em Administradores antes de ativar WhatsApp."
                )}
              </small>
            ) : null}
          </div>

          <div className="form-group">
            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span>{props.t("Combustível — alertas de abastecimento")}</span>
              <button
                type="button"
                className="sidebar-menu-info-btn"
                style={{ position: "static", margin: 0 }}
                title={props.t("Como funcionam os alertas de abastecimento?")}
                aria-label={props.t("Como funcionam os alertas de abastecimento?")}
                onClick={() => setShowFuelAlertHelp(true)}
              >
                <FaInfoCircle />
              </button>
            </label>
            <small className="help-block text-muted" style={{ marginBottom: 12 }}>
              {props.t(
                "Usados pela plataforma para detectar erros ou fraudes em abastecimentos. Clique no (i) para detalhes."
              )}
            </small>

            <label htmlFor="id_capacity" style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span>{props.t("Capacidade máxima do tanque (L)")}</span>
              <button
                type="button"
                className="sidebar-menu-info-btn"
                style={{ position: "static", margin: 0 }}
                title={props.t("Como funciona a capacidade do tanque?")}
                aria-label={props.t("Como funciona a capacidade do tanque?")}
                onClick={() => setShowFuelAlertHelp(true)}
              >
                <FaInfoCircle />
              </button>
            </label>
            <input
              type="number"
              id="id_capacity"
              value={tankCapacityLiters}
              onChange={(e) => setTankCapacityLiters(e.target.value)}
              name="capacity"
              min="1"
              max="5000"
              step="1"
              className="form-control"
              placeholder={props.t("Ex.: 400")}
            />

            {usesHourFuelLimits ? (
              <>
                <label
                  htmlFor="id_fuel_consumption_min_lph"
                  style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}
                >
                  <span>{props.t("Consumo mínimo (L/h)")}</span>
                  <button
                    type="button"
                    className="sidebar-menu-info-btn"
                    style={{ position: "static", margin: 0 }}
                    title={props.t("Como funciona o consumo mínimo?")}
                    aria-label={props.t("Como funciona o consumo mínimo?")}
                    onClick={() => setShowFuelAlertHelp(true)}
                  >
                    <FaInfoCircle />
                  </button>
                </label>
                <input
                  type="number"
                  id="id_fuel_consumption_min_lph"
                  value={fuelConsumptionMinLph}
                  onChange={(e) => setFuelConsumptionMinLph(e.target.value)}
                  name="fuel_consumption_min_lph"
                  min="0"
                  step="0.1"
                  className="form-control"
                  placeholder={props.t("Ex.: 8")}
                />

                <label
                  htmlFor="id_fuel_consumption_max_lph"
                  style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}
                >
                  <span>{props.t("Consumo máximo (L/h)")}</span>
                  <button
                    type="button"
                    className="sidebar-menu-info-btn"
                    style={{ position: "static", margin: 0 }}
                    title={props.t("Como funciona o consumo máximo?")}
                    aria-label={props.t("Como funciona o consumo máximo?")}
                    onClick={() => setShowFuelAlertHelp(true)}
                  >
                    <FaInfoCircle />
                  </button>
                </label>
                <input
                  type="number"
                  id="id_fuel_consumption_max_lph"
                  value={fuelConsumptionMaxLph}
                  onChange={(e) => setFuelConsumptionMaxLph(e.target.value)}
                  name="fuel_consumption_max_lph"
                  min="0"
                  step="0.1"
                  className="form-control"
                  placeholder={props.t("Ex.: 18")}
                />
              </>
            ) : null}

            {usesKmFuelLimits ? (
              <>
                <label
                  htmlFor="id_fuel_consumption_min_kpl"
                  style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}
                >
                  <span>{props.t("Rendimento mínimo (km/L)")}</span>
                  <button
                    type="button"
                    className="sidebar-menu-info-btn"
                    style={{ position: "static", margin: 0 }}
                    title={props.t("Como funciona o rendimento mínimo?")}
                    aria-label={props.t("Como funciona o rendimento mínimo?")}
                    onClick={() => setShowFuelAlertHelp(true)}
                  >
                    <FaInfoCircle />
                  </button>
                </label>
                <input
                  type="number"
                  id="id_fuel_consumption_min_kpl"
                  value={fuelConsumptionMinKpl}
                  onChange={(e) => setFuelConsumptionMinKpl(e.target.value)}
                  name="fuel_consumption_min_kpl"
                  min="0"
                  step="0.01"
                  className="form-control"
                  placeholder={props.t("Ex.: 2.5")}
                />

                <label
                  htmlFor="id_fuel_consumption_max_kpl"
                  style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}
                >
                  <span>{props.t("Rendimento máximo (km/L)")}</span>
                  <button
                    type="button"
                    className="sidebar-menu-info-btn"
                    style={{ position: "static", margin: 0 }}
                    title={props.t("Como funciona o rendimento máximo?")}
                    aria-label={props.t("Como funciona o rendimento máximo?")}
                    onClick={() => setShowFuelAlertHelp(true)}
                  >
                    <FaInfoCircle />
                  </button>
                </label>
                <input
                  type="number"
                  id="id_fuel_consumption_max_kpl"
                  value={fuelConsumptionMaxKpl}
                  onChange={(e) => setFuelConsumptionMaxKpl(e.target.value)}
                  name="fuel_consumption_max_kpl"
                  min="0"
                  step="0.01"
                  className="form-control"
                  placeholder={props.t("Ex.: 6.0")}
                />
              </>
            ) : null}

            <div style={{ marginTop: 16 }}>
              <label>{props.t("App de campo — no abastecimento")}</label>
              <p className="help-block text-muted" style={{ marginBottom: 8 }}>
                {props.t(
                  "A leitura manual do horímetro ou hodômetro é sempre obrigatória ao abastecer. As opções abaixo definem fotos e hectares extras."
                )}
              </p>
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={requireFuelingPanelPhoto}
                    onChange={(e) => setRequireFuelingPanelPhoto(e.target.checked)}
                  />{" "}
                  {props.t("Exigir foto do horímetro/hodômetro")}
                </label>
              </div>
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={requireFuelingGaugePhoto}
                    onChange={(e) => setRequireFuelingGaugePhoto(e.target.checked)}
                  />{" "}
                  {props.t("Exigir foto do marcador de combustível")}
                </label>
              </div>
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={requireFuelingSupplyPhoto}
                    onChange={(e) => setRequireFuelingSupplyPhoto(e.target.checked)}
                  />{" "}
                  {props.t("Exigir foto do abastecimento (bomba, nota ou comprovante)")}
                </label>
              </div>
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={requireFuelingHectares}
                    onChange={(e) => setRequireFuelingHectares(e.target.checked)}
                  />{" "}
                  {props.t("Exigir informar hectares do painel")}
                </label>
              </div>
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={requireFuelingHectaresPhoto}
                    onChange={(e) => setRequireFuelingHectaresPhoto(e.target.checked)}
                  />{" "}
                  {props.t("Exigir foto do contador de hectares")}
                </label>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="id_registration_notes">
              {props.t("Observações da máquina")}
            </label>
            <textarea
              id="id_registration_notes"
              value={registrationNotes}
              onChange={(e) => setRegistrationNotes(e.target.value)}
              name="registration_notes"
              className="form-control"
              rows={4}
              placeholder={props.t(
                "Informações que a equipe considerar úteis: motor, modelo, placa, oficina, etc."
              )}
            />
          </div>

          <div align="center">
            <input
              type="submit"
              className="btn btn-primary"
              value={props.t("Salvar")}
            />
            <Link
              to={`/${farmId}/equipment/machine/`}
              className="btn btn-default"
            >
              {props.t("Cancelar")}
            </Link>
          </div>
        </form>
        {showSpeedAlertHelp ? (
          <SidebarToolInfoModal
            title={props.t(MACHINE_SPEED_ALERT_HELP_TITLE)}
            onClose={() => setShowSpeedAlertHelp(false)}
          >
            <MachineSpeedAlertHelpContent />
          </SidebarToolInfoModal>
        ) : null}
        {showFuelAlertHelp ? (
          <SidebarToolInfoModal
            title={props.t(MACHINE_FUEL_ALERT_HELP_TITLE)}
            onClose={() => setShowFuelAlertHelp(false)}
          >
            <MachineFuelAlertHelpContent meterType={meterType} />
          </SidebarToolInfoModal>
        ) : null}
        {showFormHelp ? (
          <SidebarToolInfoModal
            title={props.t(MACHINE_FORM_HELP_TITLE)}
            onClose={() => setShowFormHelp(false)}
          >
            <MachineFormHelpContent meterType={meterType} />
          </SidebarToolInfoModal>
        ) : null}
        <ToastContainer />
      </div>
    </>
  );
}

export default withTranslation()(withRouter(FormMachine));
